<template>
  <div class="stickyBanner">
    <slot></slot>
  </div>
</template>
<script>
export default {
  //model: {
  //	prop: ''
  //},
  components: {},
  data() {
    return {}
  },
}
</script>
<style scoped>
.stickyBanner {
  border: 1px solid #358345;
  background-color: var(--v-customBackground-base);
  position: sticky;
  top: 4rem;
  z-index: 30;
}
</style>
